import { DeleteBrandFanGroupActionTypes } from '@store/brandFans'

export const deleteBrandFanGroup = (groupId: number) => ({
  payload: { groupId },
  type: DeleteBrandFanGroupActionTypes.DELETE_REQUEST,
})

export const deleteBrandFanGroupSuccess = (groupId: number) => ({
  payload: { groupId },
  type: DeleteBrandFanGroupActionTypes.DELETE_SUCCESS,
})

export const deleteBrandFanGroupError = (error: any) => ({
  payload: error,
  type: DeleteBrandFanGroupActionTypes.DELETE_ERROR,
})
